

























































































import {Vue, Component} from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';

@Component({
  directives: {
    ClickOutside
  }
})
export default class JudgementListContent extends Vue {
  public showCustomProperty: boolean = true;
}
